import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { PageHeader, Form, Card, Spin } from "antd";
import { ProjectOutlined } from "@ant-design/icons";
import { handleApiError, handleApiSuccess, MyBreadcrumb } from "utils";
import { ticketProjectByIdService, ticketProjectUpdateService } from "services/tickets";
import { TicketAccessGate } from "../_useTicketAccess";
import TicketProjectForm from "./form";
import TicketBusy, { TicketProgressBar } from "../_components/TicketAsync";
import "../_styles.css";

function UpdateContent() {
  const { id } = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [project, setProject] = useState(null);

  useEffect(() => {
    ticketProjectByIdService(id)
      .then((res) => {
        const item = res.data.item;
        setProject(item);
        form.setFieldsValue({
          name: item.name,
          description: item.description,
          color: item.color,
          prefix: item.prefix,
          members: (item.members || []).map((m) => m._id || m),
        });
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        handleApiError(err);
      });
  }, [id, form]);

  const onFinish = (values) => {
    setLoading(true);
    ticketProjectUpdateService(id, values)
      .then((res) => {
        handleApiSuccess(res);
        history.push("/tickets/projects/board/" + id);
      })
      .catch((err) => {
        setLoading(false);
        handleApiError(err);
      });
  };

  if (fetching) return <Spin style={{ display: "block", margin: "80px auto" }} />;

  return (
    <div className="ticket-system">
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Tickets", path: "/tickets/dashboard" },
          { label: "Projects", path: "/tickets/projects" },
          { label: project?.name || "Edit", path: "" },
        ]}
      />
      <PageHeader title={"Edit: " + (project?.name || "")} avatar={{ icon: <ProjectOutlined /> }} />
      <TicketProgressBar active={loading} />
      <Card>
        <TicketBusy spinning={loading} tip="Saving project…">
          <TicketProjectForm form={form} onFinish={onFinish} loading={loading} submitLabel="Save Changes" />
        </TicketBusy>
      </Card>
    </div>
  );
}

export default function TicketProjectUpdate() {
  return (
    <TicketAccessGate>
      <UpdateContent />
    </TicketAccessGate>
  );
}
